"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.getTitleColor = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _backgrounds = require("./backgrounds.js");
var _assistants = require("./assistants.js");
var _controls = require("./controls.js");
var _isHexColor = _interopRequireDefault(require("validator/lib/isHexColor"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _cccisdColorPicker = _interopRequireWildcard(require("cccisd-color-picker"));
var _reactRedux = require("react-redux");
var _builder = require("../../selectors/builder.js");
var _cccisdSound = require("cccisd-sound");
var _RestrictionsLevelContext = _interopRequireDefault(require("../../other/RestrictionsLevelContext.js"));
var _settings = _interopRequireDefault(require("./settings.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fields = ['title', 'pageTitle', 'pageTitleColor', 'pageDescription', 'prevButtonTitle', 'nextButtonTitle', 'completeButtonTitle', 'feedbackButtonTitle', 'tryAgainButtonTitle', 'prevSurveyButtonTitle', 'completeMessage', 'assistant', 'assistantPosition', 'assistantAvatar', 'showTitle', 'showPageTitleDescription', 'showProgressBar', 'useSegmentedProgressBar', 'showAudioToggle', 'showCalculator', 'showFullscreenToggle', 'showPrevButton', 'background', 'backgroundColor', 'backgroundImage', 'backgroundSize', 'height', 'elementStyle', 'controlStyle', 'elementFontSize', 'showStickyBottomBar', 'ttsVoice', 'scaleContent', 'askIfSkipped', 'skippedConfirmationText'];
var initialValues = {
  title: 'Flow title',
  pageTitle: 'Checking In',
  pageTitleColor: 'primary',
  pageDescription: 'Some description',
  prevButtonTitle: 'Prev',
  nextButtonTitle: 'Next',
  completeButtonTitle: 'Complete',
  feedbackButtonTitle: 'Check answers',
  tryAgainButtonTitle: 'Try Again',
  prevSurveyButtonTitle: 'Prev',
  completeMessage: 'Thank you! The survey has been completed.',
  assistant: '',
  assistantPosition: 'side',
  assistantAvatar: {},
  showTitle: true,
  showPageTitleDescription: false,
  showProgressBar: true,
  useSegmentedProgressBar: false,
  showAudioToggle: false,
  showCalculator: false,
  showFullscreenToggle: false,
  showPrevButton: true,
  background: '',
  backgroundColor: '',
  backgroundImage: null,
  backgroundSize: 'cover',
  height: '',
  elementStyle: '',
  controlStyle: '',
  elementFontSize: 'normal',
  showStickyBottomBar: false,
  ttsVoice: null,
  scaleContent: false,
  askIfSkipped: false,
  skippedConfirmationText: 'At least one question was skipped. Would you like to proceed anyway?'
};
exports.initialValues = initialValues;
var assistantPositionOptions = [{
  label: 'Top corner',
  value: 'corner'
}, {
  label: 'Side of screen',
  value: 'side'
}, {
  label: 'Middle of screen',
  value: 'middle'
}];
var elementStyleOptions = [{
  label: 'Default',
  value: ''
}, {
  label: 'Bubble style',
  value: 'bubble'
}];
var elementFontSizeOptions = [{
  title: 'Small',
  value: 'small'
}, {
  title: 'Normal',
  value: 'normal'
}, {
  title: 'Large',
  value: 'large'
}, {
  title: 'Huge',
  value: 'huge'
}, {
  title: 'Enormous',
  value: 'enormous'
}];
var backgroundSizeOptions = [{
  label: 'Cover',
  value: 'cover'
}, {
  label: 'Scale',
  value: 'scale'
}, {
  label: 'Bottom',
  value: 'bottom'
}];
var protectedAssistants = ['ollie'];
var protectedBackgrounds = ['sciencequest'];

// Convert old colors to the new cccisd-color-picker colors
var convertTitleColor = function convertTitleColor(color) {
  var oldColors = {
    primary: 'primaryColor',
    success: 'successColor',
    info: 'infoColor',
    warning: 'warningColor',
    danger: 'dangerColor'
  };
  return color in oldColors ? oldColors[color] : color;
};
var getTitleColor = function getTitleColor(color) {
  return (0, _cccisdColorPicker.getColor)(convertTitleColor(color));
};
exports.getTitleColor = getTitleColor;
var validate = function validate(values) {
  var errors = {};
  if (values.background === 'solidColor') {
    if (!values.backgroundColor) {
      errors.backgroundColor = 'Color should be defined';
    } else if (values.backgroundColor.length !== 7 || !(0, _isHexColor["default"])(values.backgroundColor)) {
      errors.backgroundColor = 'Wrong format';
    }
  }
  return errors;
};
exports.validate = validate;
var Highlighted = function Highlighted(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].highlightedWrapper,
    style: props.style
  }, props.isHighlighted && /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].highlighted
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].body
  }, props.children));
};
var Settings = /*#__PURE__*/function (_React$Component) {
  _inherits(Settings, _React$Component);
  var _super = _createSuper(Settings);
  function Settings() {
    var _this;
    _classCallCheck(this, Settings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "TextBlock", function (props) {
      return /*#__PURE__*/_react["default"].createElement(Highlighted, {
        isHighlighted: _this.props.highlightedFields.includes(props.field.name)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, props));
    });
    _defineProperty(_assertThisInitialized(_this), "Block", function (props) {
      return /*#__PURE__*/_react["default"].createElement(Highlighted, {
        isHighlighted: _this.props.highlightedFields.includes(props.field.name),
        style: props.style
      }, props.children);
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeBackground", function (e) {
      var _this$props$fields = _this.props.fields,
        background = _this$props$fields.background,
        backgroundColor = _this$props$fields.backgroundColor;
      var value = e.target.value;
      if (value === 'uploadedImage' && _this.uploadedImageModal) {
        _this.uploadedImageModal.open();
      }
      var backgroundColorValue = value === 'solidColor' ? '#c6daf3' : '';
      backgroundColor.onChange(backgroundColorValue);
      background.onChange(e);
    });
    return _this;
  }
  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$fields2 = this.props.fields,
        title = _this$props$fields2.title,
        pageTitle = _this$props$fields2.pageTitle,
        pageTitleColor = _this$props$fields2.pageTitleColor,
        pageDescription = _this$props$fields2.pageDescription,
        prevButtonTitle = _this$props$fields2.prevButtonTitle,
        nextButtonTitle = _this$props$fields2.nextButtonTitle,
        completeButtonTitle = _this$props$fields2.completeButtonTitle,
        feedbackButtonTitle = _this$props$fields2.feedbackButtonTitle,
        tryAgainButtonTitle = _this$props$fields2.tryAgainButtonTitle,
        prevSurveyButtonTitle = _this$props$fields2.prevSurveyButtonTitle,
        completeMessage = _this$props$fields2.completeMessage,
        assistant = _this$props$fields2.assistant,
        assistantPosition = _this$props$fields2.assistantPosition,
        showTitle = _this$props$fields2.showTitle,
        showPageTitleDescription = _this$props$fields2.showPageTitleDescription,
        showProgressBar = _this$props$fields2.showProgressBar,
        useSegmentedProgressBar = _this$props$fields2.useSegmentedProgressBar,
        showAudioToggle = _this$props$fields2.showAudioToggle,
        showCalculator = _this$props$fields2.showCalculator,
        showFullscreenToggle = _this$props$fields2.showFullscreenToggle,
        showPrevButton = _this$props$fields2.showPrevButton,
        showStickyBottomBar = _this$props$fields2.showStickyBottomBar,
        scaleContent = _this$props$fields2.scaleContent,
        background = _this$props$fields2.background,
        backgroundColor = _this$props$fields2.backgroundColor,
        height = _this$props$fields2.height,
        elementStyle = _this$props$fields2.elementStyle,
        controlStyle = _this$props$fields2.controlStyle,
        elementFontSize = _this$props$fields2.elementFontSize,
        backgroundImage = _this$props$fields2.backgroundImage,
        backgroundSize = _this$props$fields2.backgroundSize,
        ttsVoice = _this$props$fields2.ttsVoice,
        askIfSkipped = _this$props$fields2.askIfSkipped,
        skippedConfirmationText = _this$props$fields2.skippedConfirmationText;
      var restrictionsLevel = this.context;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showTitle
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showTitle), {
        type: "checkbox"
      })), " Show title")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showPageTitleDescription
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showPageTitleDescription), {
        type: "checkbox"
      })), " Show page title and description")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showProgressBar
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showProgressBar), {
        type: "checkbox"
      })), " Show progress bar")), showProgressBar.value ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginLeft: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: useSegmentedProgressBar
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(useSegmentedProgressBar), {
        type: "checkbox"
      })), " Use segmented progress bar"))) : null, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showAudioToggle
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showAudioToggle), {
        type: "checkbox"
      })), " Show audio toggle")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showCalculator
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showCalculator), {
        type: "checkbox"
      })), " Show calculator")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showPrevButton
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showPrevButton), {
        type: "checkbox"
      })), " Show prev button")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showStickyBottomBar
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showStickyBottomBar), {
        type: "checkbox"
      })), " Show navigation bar at the bottom of the page")), showStickyBottomBar.value ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginLeft: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showFullscreenToggle
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(showFullscreenToggle), {
        type: "checkbox"
      })), " Show fullscreen toggle")), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: scaleContent
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(scaleContent), {
        type: "checkbox"
      })), " Scale content to fit available height"))) : null)), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: elementFontSize,
        label: "Font size for elements"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].fontSizeWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group",
        style: {
          marginRight: '15px'
        }
      }, elementFontSizeOptions.map(function (size) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          key: size.value,
          type: "button",
          className: "btn btn-default ".concat(elementFontSize.value === size.value && 'active'),
          onClick: function onClick() {
            return elementFontSize.onChange(size.value);
          }
        }, size.title);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_settings["default"].example, " ").concat(_settings["default"][elementFontSize.value])
      }, "Example text with this font size"))), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: title,
        label: "Navigation title",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minWidth: '16rem'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: pageTitle,
        label: "Page title",
        isWysiwyg: true
      })), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: pageTitleColor,
        style: {
          zIndex: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        label: "Color",
        field: pageTitleColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
        value: convertTitleColor(pageTitleColor.value),
        onChange: pageTitleColor.onChange
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flexGrow: 1
        }
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: pageDescription,
        label: "Page instructions",
        isWysiwyg: true
      }))), /*#__PURE__*/_react["default"].createElement("h4", null, "Button Text"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid,
        style: {
          marginBottom: '0.7em'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: prevButtonTitle,
        label: "Prev page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: nextButtonTitle,
        label: "Next page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: completeButtonTitle,
        label: "Complete page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: feedbackButtonTitle,
        label: "Feedback",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: tryAgainButtonTitle,
        label: "Try Again",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: prevSurveyButtonTitle,
        label: "Prev survey",
        isWysiwyg: true
      })), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: completeMessage,
        label: "Complete message",
        inputStyle: {
          minWidth: '500px'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: elementStyle
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Element style")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(elementStyle), {
        value: elementStyle.value
      }), elementStyleOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: controlStyle
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Navigation bar style")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(controlStyle), {
        value: controlStyle.value
      }), _controls.controlOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: background
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Background")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(background), {
        onChange: this.onChangeBackground,
        value: background.value
      }), _backgrounds.backgroundOptions.filter(function (option) {
        return !protectedBackgrounds.includes(option.value) || option.value === background.value;
      }).map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "solidColor"
      }, "Solid Color"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "uploadedImage"
      }, "Upload Image")))), background.value === 'uploadedImage' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundImage
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.ImagePickerBlock, {
        value: backgroundImage.value,
        onChange: backgroundImage.onChange
      }))), backgroundImage.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm",
        style: {
          marginLeft: '-0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundImage
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: backgroundImage.value.name,
        src: backgroundImage.value.thumbnailSmall,
        width: "60px",
        style: {
          borderRadius: '5px'
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundSize
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Background size")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(backgroundSize), {
        value: backgroundSize.value
      }), backgroundSizeOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))))), background.value === 'solidColor' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        label: "Color (e.g. #c6daf3)",
        field: backgroundColor
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(backgroundColor), {
        style: {
          maxWidth: '100px'
        }
      })), backgroundColor.valid && /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].backgroundSample,
        style: {
          backgroundColor: backgroundColor.value
        }
      })))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: assistant
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Assistant")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(assistant), {
        value: assistant.value,
        style: {
          width: 'auto'
        }
      }), _assistants.assistantOptions.filter(function (option) {
        return !protectedAssistants.includes(option.value) || option.value === assistant.value;
      }).map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "avatar"
      }, "Avatar"))))), assistant.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: assistantPosition
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Assistant position")), assistantPositionOptions.map(function (position) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: position.value,
          className: "radio-inline"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(assistantPosition), {
          value: position.value,
          checked: assistantPosition.value === position.value
        })), ' ', position.label);
      }))))), restrictionsLevel !== 'basic' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: ttsVoice
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, "Text-to-Speech Voice")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].voiceWrapper
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-control"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(ttsVoice), {
        value: ttsVoice.value,
        style: {
          width: 'auto'
        }
      }), this.props.ttsVoiceOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default btn-sm",
        onClick: function onClick() {
          var option = _this2.props.ttsVoiceOptions.find(function (item) {
            return item.value === ttsVoice.value;
          }) || _this2.props.ttsVoiceOptions[0];
          (0, _cccisdSound.play)(option.url);
        }
      }, /*#__PURE__*/_react["default"].createElement(_play["default"], null)))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group form-group-sm"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: askIfSkipped
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(askIfSkipped), {
        type: "checkbox"
      })), " ask confirmation if the question is skipped")))), askIfSkipped.value ? /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: skippedConfirmationText,
        label: "Skipped confirmation text"
      }) : null, !showStickyBottomBar.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: height,
        label: "Minimum page height",
        comment: "Leave blank for auto height",
        inputStyle: {
          width: 'auto'
        }
      })));
    }
  }]);
  return Settings;
}(_react["default"].Component);
_defineProperty(Settings, "propTypes", {
  fields: _propTypes["default"].object,
  highlightedFields: _propTypes["default"].array
});
_defineProperty(Settings, "defaultProps", {
  highlightedFields: []
});
Settings.contextType = _RestrictionsLevelContext["default"];
var mapStateToProps = function mapStateToProps(state) {
  return {
    ttsVoiceOptions: (0, _builder.getLanguageVoices)(state.flow.builder)
  };
};
var ConnectedSettings = (0, _reactRedux.connect)(mapStateToProps)(Settings);
var _default = (0, _cccisdSurveyCommon.templateSettingsWrapper)({
  fields: fields,
  validate: validate,
  initialValues: initialValues
})(ConnectedSettings);
exports["default"] = _default;